import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  formHelperText: {
    margin: 0,
    marginLeft: 8,
    paddingBottom: 8,
  },
});
